import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=5af8cf3e&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af8cf3e')) {
      api.createRecord('5af8cf3e', component.options)
    } else {
      api.reload('5af8cf3e', component.options)
    }
    module.hot.accept("./Integration.vue?vue&type=template&id=5af8cf3e&", function () {
      api.rerender('5af8cf3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/Integration.vue"
export default component.exports